$(document).ready(function () {
    // move header out of the way
    const $header = LS.getHeader();
    const headerHeight = $header.outerHeight();
    let scrollPos = $(window).scrollTop();
    $(window).on("scroll", function () {
        let newPosition = $(window).scrollTop();
        // build in some buffering
        if (Math.abs(newPosition - scrollPos) > 60) {
            if (newPosition > scrollPos) {
                // scrolling down
                if (newPosition > headerHeight) {
                    $header.addClass("is-scrolled");
                }
            } else {
                // scrolling up
                $header.removeClass("is-scrolled");
            }
            scrollPos = newPosition;
            if (newPosition <= headerHeight) {
                $('body').css('padding-top', 0);
                $header.css('position', 'sticky');
            } else {
                $('body').css('padding-top', headerHeight);
                $header.css('position', 'fixed');
            }
        }
    });

    const $marquee = $("#marquee");

    function closeHeaderPanels() {
        $("body").removeClass("site-menu-open search-open");
        $('#site-header [aria-expanded="true"]').attr("aria-expanded", false);
        LS.returnFocus();
    }

    function closeMenus() {
        let $el = $(".navigate-down");
        $el.attr("aria-expanded", false);
        $el.closest("li").removeClass("active");
        $el.next(".sub-menu").find("a, button").attr("tabindex", "-1");
        $("body").removeClass("sub-menu-open");
    }

    // keyboard close things
    $("body").on("keyup", function (e) {
        if (LS.isEscape(e)) {
            closeHeaderPanels();
            closeMenus();
            closeSearch();
        }
    });

    // click anywhere to close things
    $(".site-content").on("click", function (e) {
        if (
            $("body").hasClass("site-menu-open") ||
            $("body").hasClass("search-open")
        ) {
            closeHeaderPanels();
        }
        if ($("body").hasClass("sub-menu-open")) {
            closeMenus();
        }
    });

    $("#site-menu-toggle").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        window.returnFocusTo = $(this);
        $("body").toggleClass("site-menu-open");
        if ($("body").hasClass("site-menu-open")) {
            $(this).attr("aria-expanded", true);
            $(this).attr("aria-label", "close site navigation");
        } else {
            $(this).attr("aria-expanded", false);
            $(this).attr("aria-label", "open site navigation");
            $("#site-menu-items li").removeClass("active");
            $("#site-menu-items ul").find("a, button").attr("tabindex", "-1");
        }
        $("body").removeClass("search-open");
    });

    $(".navigate-down").on("click", function (e) {
        e.preventDefault();
        window.returnFocusTo = $(this);
        if ($(this).closest("li").hasClass("active")) {
            closeMenus();
            return;
        }
        closeMenus();
        $(this).closest("li").addClass("active");
        $(this).attr("aria-expanded", true);
        $(this)
            .next(".sub-menu")
            .find("a, button:not(.navigate-up)")
            .attr("tabindex", "0");
        if (window.outerWidth >= 992) {
            $("body").addClass("sub-menu-open");
            LS.trapFocus("#" + $(this).next(".sub-menu").attr("id"), false);
        }
    });

    $(".navigate-up").on("click", function (e) {
        e.preventDefault();
        let $parent = $(this).closest("li.active");
        let grandParentId = $parent.closest("ul").attr("id");
        $(this).closest(".sub-menu").find("a, button").attr("tabindex", "-1");
        $parent.removeClass("active");
        if (window.outerWidth >= 992) {
            // don't selecct the first focusable in the traps below because we want to focus the parent of this sub-menu
            if (grandParentId === "site-menu-items") {
                LS.trapFocus("#site-menu-panel", false); // go further up to catch the close button too
            } else {
                LS.trapFocus("#" + grandParentId, false);
            }
            setTimeout(() => {
                $parent.find(".navigate-down").first().focus();
            }, 350);
        }
    });

    // // prevent menu panel actions from closing the panel
    // // $('#site-menu-panel').on('click', function (e) {
    // //     e.stopPropagation();
    // // });

    // // save the menu state
    // $('body').on('click', '.navigate-down, .navigate-up', function (e) {
    //     e.preventDefault();
    //     sessionStorage.setItem("lo-menu-state", $('#site-menu').html());
    // });
    // // load menu state
    // if ('lo-menu-state' in sessionStorage) {
    //     $('#site-menu').html(sessionStorage.getItem('lo-menu-state'));
    // }

    /*
    Marquee
      */

    var $marqueeSlider = $marquee.find(".items");
    var $shippingItem = $marqueeSlider.find(".appended");

    if ($marqueeSlider.length) {
        $marqueeSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3500,
            prevArrow:
                '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6377 22.203L2 11.6015L11.6377 1.00009" stroke="currentColor" stroke-width="1.5"/> </svg> </button>',
            nextArrow:
                '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.637701 22.2029L10.2754 11.6015L0.637701 1.00003" stroke="currentColor" stroke-width="1.5"/> </svg> </button>',
        });

        // update marquee with shipping message
        if (window.theme.cartTotal > 0 && !$shippingItem.length) {
            $marqueeSlider.slick(
                "slickAdd",
                '<div class="item appended"></div>',
                0,
                true
            );
            $shippingItem = $marqueeSlider.find(".appended");
        }
    }
    LS.updateFreeShippingMessages();

    // $marquee.find('.panel-close').on('click', function (e) {
    //     e.preventDefault();
    //     $('body').removeClass('has-marquee');
    //     sessionStorage.setItem('lo-marquee-dismissed', true);
    // });

    function closeSearch() {
        $("body").removeClass("search-open");
        $('.search-collapse').attr("aria-hidden", true);
        $('.search-collapse').find("button, input").attr("tabindex", -1);
        $('.search-collapse').next(".search-open").attr("aria-expanded", false);
        LS.returnFocus();
    }

    $(".search-open").on("click", function (e) {
        e.preventDefault();
        window.returnFocusTo = $(this);
        $("body").addClass("search-open").removeClass("site-menu-open");
        $(this).attr("aria-expanded", true);
        $target = $(this).prev(".search-collapse");
        $target.attr("aria-hidden", false);
        $target.find("button, input").attr("tabindex", 0);
        LS.trapFocus(`#${$target.attr('id')}`, false);
        setTimeout(() => {
            $target.find('.form-control').select();
        }, 400);
    });
    $(".search-close").on("click", function (e) {
        e.preventDefault();
        closeSearch();
    });
});
